import model from 'modules/customer/customerModel';

const { fields } = model;

export default [
  fields.id,
  fields.name,
  fields.cellphone,
  fields.email,
  fields.documentNumber,
  fields.company,
  fields.enable,
  fields.createdAt,
  fields.updatedAt
];
